// @ts-nocheck
import { useEffect, useRef } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { usePushNotifications } from '@/hooks/usePushNotifications';

/**
 * Renderiza nada. Se o usuário acabou de entrar no PWA E:
 *   - permissão de notificação = 'granted'
 *   - status atual = 'not-subscribed'
 * tenta subscrever silenciosamente.
 *
 * Mantemos isso desacoplado da tela de Notificações porque o push é
 * "a alma do app": queremos que o usuário nunca fique sem receber
 * alertas só porque esqueceu de revisitar aquela tela.
 */
export const PwaAutoSubscribe = () => {
  const { user } = useAuth();
  const { status, subscribe } = usePushNotifications();
  const triedRef = useRef(false);

  useEffect(() => {
    if (!user) return;
    if (triedRef.current) return;
    if (typeof Notification === 'undefined') return;
    if (Notification.permission !== 'granted') return;
    if (status !== 'not-subscribed') return;

    triedRef.current = true;
    subscribe().catch((err) => {
      console.warn('[PwaAutoSubscribe] Falha silenciosa:', err);
    });
  }, [user, status, subscribe]);

  return null;
};
